export default __webpack_public_path__ + "static/media/search-icon-light.676bb25f.svg";